import CustomModal from "../CustomModal";

const EnableUserModal = ({
  isOpen,
  onRequestClose,
  selectedMember,
  onEnableUser,
}) => {
  // Don't render modal if no selectedMember
  if (!selectedMember) {
    return null;
  }

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="delete-modal"
    >
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/enable-modal-img.png`}
          alt="Enable user icon"
        />
        <b>
          <p>
            Are you sure you want to enable user access for the selected user?
          </p>
        </b>
          <div className="details-container container">
            <div className="detail">
              <p>Name</p>
              <b>
                <p className="D">
                  {selectedMember.l_name} {selectedMember.f_name}
                </p>
              </b>
            </div>
            <div className="detail">
              <p>Gym Number</p>
              <b>
                <p className="D">#{selectedMember.id}</p>
              </b>
            </div>
            <div className="detail">
              <p>Access Status</p>
              <b>
                <p className="D">
                  {selectedMember.access_status === 1 ? "Enabled" : "Disabled"}
                </p>
              </b>
            </div>
          </div>
          <div className="warning">
            <img
              src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
              alt="Information icon"
            />
            <p>
              Note that enabling user access will allow the user to have access
              to the gym premises or any associated services.
            </p>
          </div>
          <div className="inner-member-btn">
            <button onClick={onRequestClose}>Cancel</button>
            <button
              style={{ backgroundColor: "#34B159", color: "#FAFAFA" }}
              onClick={onEnableUser}
            >
            Grant access
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default EnableUserModal;
